export const tabview = {
  colorScheme: {
    light: {
      tabList: {
        background: '{surface.0}',
      },

      tabPanel: {
        background: '{surface.0}',
      },
    },
    dark: {
      tabList: {
        background: '#3c434f',
        borderColor: '#5B5F69',
      },
      tab: {
        color: 'white',
        hoverColor: 'white',
        activeColor: 'white',
        borderColor: '#5B5F69',
      },
      tabPanel: {
        background: '#3c434f',
        color: 'white',
      },
      navButton: {
        background: '#3c434f',
        color: 'white',
      },
    },
  },
};
